import classNames from "classnames";

import { defer } from "../../../../utils/script";
import { DComponent } from "../../../../components/DComponent";
import PaymentList from "./components/PaymentList";
// eslint-disable-next-line no-unused-vars
import { PaymentMethod } from "../../../../models/PaymentMethod";

export default class PaymentInfo extends DComponent {
  constructor({
    parent,
    id,
    onSelectPayment,
    listPayment = [],
    onResetPayment,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("PaymentInfo", {

      })
    }, true);
    this.listPayment = listPayment;
    this.onSelectPayment = onSelectPayment;
    this.onResetPayment = onResetPayment;
    /**@type {[PaymentMethod]} */
    this.myPaymentList = [];
    /**@type {[PaymentMethod]} */
    this.paymentList = listPayment;
    /**@type {PaymentList} */
    this.savedPaymentList = undefined;
    /**@type {PaymentList} */
    this.otherPaymentList = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "PaymentInfo");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.otherPaymentList = new PaymentList({
      parent: $(".other-payment-list .data", this.element),
      paymentList: this.listPayment,
      onSelectPayment: this.onSelectPayment
    })
  }

  /** @param {PaymentInfo} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
      this.updateData();
    });
  }

  updateData() {
    this.paymentList = this.listPayment;
    this.otherPaymentList.updateAttributes({
      paymentList: this.paymentList,
      onSelectPayment: this.onSelectPayment,
    });
  }

  validatePayment() {
    let result = false;
    defer(() => this.otherPaymentList, () => {
      result = this.otherPaymentList.validatePaymentList()
    })
    return result;
  }

  /** @returns {PaymentMethod}*/
  getCurrentPayment() {
    return this.otherPaymentList.getCurrentPayment();
  }

  resetPayment() {
    defer(() => this.otherPaymentList, () => {
      this.otherPaymentList.resetPaymentList();
      this.isShorten(false);
      typeof this.onResetPayment === "function" && this.onResetPayment();
    })
  }

  isShorten(isShort) {
    defer(() => this.otherPaymentList, () => {
      this.otherPaymentList.isShorten(isShort);
    })
  }

  showPaymentItem(paymentMethod, paymentProvider, isShow) {
    this.otherPaymentList.showPaymentItem(paymentMethod, paymentProvider, isShow);
  }
}